import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门话题', href: '#topics' },
  { label: '特色优势', href: '#features' },
  { label: '读者热评', href: '#comments' },
  { label: '焦点专题', href: '#carousel' },
  { label: '最新快讯', href: '#updates' },
  { label: 'APP下载', href: '#app' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[68px]">
          <a
            href="#hero"
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <span className="text-xl md:text-2xl font-heading font-bold text-primary-500">
              爆瓜网
            </span>
            <span className="hidden sm:inline text-xs text-foreground-500 bg-accent-100/80 px-2 py-0.5 rounded-full">
              每日更新
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 transition-colors rounded-md hover:bg-background-100 whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button className="flex items-center gap-1.5 px-4 py-2 text-sm bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-search-line w-4 h-4 flex items-center justify-center"></i>
              搜瓜
            </button>
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background-50 border-t border-background-200/70 px-4 pb-4">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className="block py-3 text-sm text-foreground-700 hover:text-primary-500 transition-colors border-b border-background-100 last:border-0 whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}